// src/utils/formatEmail.js
export const TextSlicer = (text, maxLength = 25) => {
  if (!text) return "";

  if (text.length <= maxLength) return text;

  return text.slice(0, maxLength) + "...";
};
